import * as React from 'react';
import { createComponent } from '@lit/react';
import { Divider as SpDivider } from '@spectrum-web-components/divider';

import '@spectrum-web-components/divider/sp-divider.js';

export const Divider = createComponent({
    displayName: 'Divider',
    elementClass: SpDivider,
    react: React,
    tagName: 'sp-divider',
    events: {},
});

export type DividerType = EventTarget & SpDivider;
